import { render, staticRenderFns } from "./EditorDetail.vue?vue&type=template&id=015a49aa&scoped=true"
import script from "./EditorDetail.vue?vue&type=script&lang=js"
export * from "./EditorDetail.vue?vue&type=script&lang=js"
import style0 from "./EditorDetail.vue?vue&type=style&index=0&id=015a49aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015a49aa",
  null
  
)

export default component.exports